export enum MileageReimbursementType {
  CUSTOM = "CUSTOM",
  BUSINESS = "BUSINESS",
  CHARITY = "CHARITY",
}
